import React from 'react';
import { Building2, Users, FileSearch, TrendingUp, Flag, Heart, Gift, Cross } from 'lucide-react';
import { RadialOrbitalTimeline } from './RadialOrbitalTimeline';
const timelineData = [{
  id: 1,
  title: 'Systems & Technology',
  date: '2024',
  content: 'Our consolidated resources, software, processes, and systems will be applied to all locations and promote an efficient and effective operational platform built for scale.',
  category: 'Operations',
  icon: Building2,
  relatedIds: [2, 3],
  status: 'completed' as const,
  energy: 100
}, {
  id: 2,
  title: 'Economies of Scale',
  date: '2024',
  content: 'We will have multiple locations within each strategic region to maximize economies of scale and capture additional market share.',
  category: 'Growth',
  icon: TrendingUp,
  relatedIds: [1, 4],
  status: 'completed' as const,
  energy: 90
}, {
  id: 3,
  title: 'Data Management',
  date: '2024',
  content: 'We train our clinical staff to document accordingly, and when coupled with our operational metrics, we increase efficiencies while also generating a market value for our data.',
  category: 'Operations',
  icon: FileSearch,
  relatedIds: [1, 4],
  status: 'in-progress' as const,
  energy: 80
}, {
  id: 4,
  title: 'Referral & Census Growth',
  date: '2024',
  content: 'We drive patient census by acting on a referral within 3 hours, instead of the industry standard of 48. We also leverage strategic performance metrics which help maximize our time, effectiveness, success rates, and the quality of industry partnerships.',
  category: 'Growth',
  icon: TrendingUp,
  relatedIds: [2, 3],
  status: 'in-progress' as const,
  energy: 75
}, {
  id: 5,
  title: 'Veteran Recognition',
  date: '2024',
  content: 'We honor veterans by providing recognition ceremonies, flag presentations, and other acts of appreciation to help veterans and their families feel respected and valued.',
  category: 'Community',
  icon: Flag,
  relatedIds: [6, 7, 8],
  status: 'completed' as const,
  energy: 100
}, {
  id: 6,
  title: 'Staff Support & Culture Care',
  date: '2024',
  content: 'Family-oriented approach of supporting personnel outside of work, promoting growth in the workplace, and community engagement. This promotes longevity of our staff and results in low turnover.',
  category: 'Culture',
  icon: Heart,
  relatedIds: [5, 7, 8],
  status: 'completed' as const,
  energy: 95
}, {
  id: 7,
  title: 'Stewardship & Giving',
  date: '2024',
  content: 'We allocate a portion of our annual profits and personal time to give back to the community, non-profits, and strategic partners. We also include our employees and allow them to participate directly with organizations they support.',
  category: 'Community',
  icon: Gift,
  relatedIds: [5, 6, 8],
  status: 'completed' as const,
  energy: 90
}, {
  id: 8,
  title: 'Spiritual Care',
  date: '2024',
  content: 'We provide holistic care that addresses the spiritual needs of our patients and their families, recognizing the importance of faith and spiritual well-being in the healing process.',
  category: 'Care',
  icon: Cross,
  relatedIds: [5, 6, 7],
  status: 'completed' as const,
  energy: 95
}];
export function DifferentiatorsTimeline() {
  return <RadialOrbitalTimeline timelineData={timelineData} data-id="element-57" />;
}